import { Overview } from "@/@types";
import { OverviewResponse } from "../../partsServices/models/PartsServicesResponse";

export function mapOverview(overview: OverviewResponse): Overview {

  return {
    description: overview.description,
    image: overview.media,
  }
}